import React from 'react';
import wx from 'weixin-js-sdk';
import util from 'Utiljs';
import api from 'Api';
import Constant from 'Constantjs';

import Activation from 'Common/Activation';

import { Toast, Modal } from 'antd-mobile';

// 设置rem
const setHtmlFontSize = (doc) => {
  const htmlDom = doc.documentElement;
  const docWidth = htmlDom.clientWidth;
  const countFontSize = Math.round(100 * (docWidth / 375));
  htmlDom.style.fontSize = `${countFontSize}px`;
};
// 获取系统默认字体大小
// designWidth 设计稿的宽度
// rem2px 设计稿宽度下，1rem的宽度
const adapt = () => {
  const d = window.document.createElement('p');
  d.style.width = '1rem';
  d.style.display = "none";
  const head = window.document.getElementsByTagName('head')[0];
  head.appendChild(d);
  const defaultFontSize = parseFloat(window.getComputedStyle(d, null).getPropertyValue('width'));
  d.remove();
  return defaultFontSize;
};
// 安卓系统设置字体大小
const changeFontSize = (doc, win, designWidth, rem2px, defaultFontSize) => {
  const docEl = doc.documentElement;
  const p = window.document.createElement('p');
  document.body.appendChild(p);
  const elementWidth = parseFloat(window.getComputedStyle(p, null).getPropertyValue('width'));
  p.remove();
  const clientWidth = win.innerWidth || docEl.clientWidth || doc.body.clientWidth || elementWidth || designWidth;
  if (!clientWidth) return;
  docEl.style.fontSize = `${clientWidth / designWidth * rem2px / defaultFontSize * 100}%`;
};
const setFontSize = (defaultFontSize) => {
  const os = window.sayhi.getOSType();
  if (os === 'android') {
    changeFontSize(document, window, 375, 100, defaultFontSize);
  } else {
    setHtmlFontSize(document);
  }
};

export default class BasicLayout extends React.Component  {
  constructor(props) {
    super(props);
    this.state = {
      showActivation: false,
      urlQueryParams: util.getUrlParams()
    };

    const defaultFontSize = adapt();
    setFontSize(defaultFontSize);
    window.addEventListener('resize', () => {
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(()=>{
        setFontSize(defaultFontSize);
        window.sayhi.pub('onWindowResizeCallback');
      }, 300);
    });

  }

  componentDidMount() {
    const { urlQueryParams } = this.state;
    if (urlQueryParams.userId) {
      return;
    }
    this.loginFn();
    // if (process.env.NODE_ENV === 'development') {
    window.sayhi.pub('needLogin');
    // }
  }

  getMiniapph5login(params) {
    Toast.loading('加载中...', 0);

    api.getTimestamp().then(() => {
      api.miniapph5login(params).then(res => {
        const { code, data } = res;
        if (code === 0) {
          const { user } = data;
          window.sayhi.isWebviewLoging = false;
          window.localStorage.setItem('token', JSON.stringify(user.token));
          this.getUserInfo();
        } else {
          Toast.hide();
          Modal.alert('温馨提示', '登录失败', [{
            text: '确定', 
            onPress: ()=>{
              wx.miniProgram.navigateBack();
            }
          }]);
        }
      });
    });
  }

  // 获取用户信息
  getUserInfo() {
    api.getUserData().then(res => {
      const { code, data, message } = res;
      Toast.hide();
      if (code === 0) {
        this.loginSuccess(data);
      } else {
        Toast.info(message);
      }
    });
  }

  static setUserInfo(data) {
    const { user, user_relation: userRelation, token } = data;
    window.mm = {
      id: user.id,
      active: user.is_active,
      subscribed: userRelation.is_subscribed,
      level_id: user.level_id
    };
    if (token) {
      window.localStorage.setItem('token', JSON.stringify(token));
    }
  }

  // 隐藏手机号注册弹框
  hideActivation() {
    this.setState({
      showActivation: false
    });
  }

  loginSuccess(userInfo) {
    const { webviewLoginCallback } = this.props;
    window.sayhi.isWebviewLoging = false;
    BasicLayout.setUserInfo(userInfo);
    webviewLoginCallback({ webviewLoginStatus: true, userInfo });
    this.hideActivation();
  }

  loginFn() {
    const { isBtgApp, isWXMiniApp } = window.sayhi;
    const { webviewLoginCallback } = this.props;
    const { urlQueryParams } = this.state;
    // 登录完成后 设置token值
    window.sayhi.sub('loginDone', (e, data) => {
      if (isBtgApp && data) {
        const str = data.slice(0, data.length - 10);
        const json = util.jsonParse(window.atob(str));
        const { xauth } = json || {};
        if (xauth) {
          window.localStorage.setItem('token', JSON.stringify(xauth));
          window.sayhi.isWebviewLoging = false;
          api.getTimestamp().then(() => {
            this.getUserInfo();
          });
          return;
        }
        webviewLoginCallback({});
        window.localStorage.removeItem('token');
      }
    });

    /**
     * 模拟btgapp
     * isBtgApp: false ==>>> isBtgApp: true
     * 调式结束记得注释
     */
    // window.sayhi.sub('onAppCall', (e, params) => {
    //   const { name, callback } = params;
    //   if (name === 'getToken') {
    //     const a = {
    //       xauth: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOjEsImF1ZCI6IlBsYXRlTWluaVd4QXBwIiwiaWF0IjoxNjQ2MDI3ODkyLCJleHAiOjE2NDYxOTkxMTgsIm5iZiI6MTY0NjE5NzMxOCwidXNlcklkIjo1Njc3MTU3LCJ2aXJ0dWFsTG9naW5GbGFnIjpmYWxzZX0.XK_JR_yr37o9knxe7emW1SpOU7agBn0zvH8z7cNLUd4'
    //     };
    //     window.sayhi.pub(callback, `${window.btoa(JSON.stringify(a))}1234567890`);
    //   }
    // });
    
    // 需要登录
    window.sayhi.sub('needLogin', () => {
      if (isBtgApp) { // 首客首享app内的登录
        if(window.sayhi.isWebviewLoging) {
          window.sayhi.pub('onAppCall', {
            name: 'login',
            params: {},
            callback: 'loginDone'
          });
          return;
        }
        window.sayhi.pub('onAppCall', {
          name: 'getToken',
          params: {},
          callback: 'loginDone'
        });
        return;
      }

      const { mobile, source, storeId, appid, openid } = urlQueryParams;
      if (mobile && source) { // 如果url中有mobile和source字段，走mobile登录
        if (Constant.miniAppSource.indexOf(source) > -1) {
          window.sayhi.otherMiniApp = source;
          this.getMiniapph5login({mobile, source, storeId, appid, openid});
        } else {
          window.sayhi.isBtgWxMiniApp = isWXMiniApp && true;
        }
        return;
      }

      if (isWXMiniApp) {
        const { userInfo } = urlQueryParams;
        if (userInfo) {
          window.sayhi.isWebviewLoging = false;
          window.localStorage.setItem('token', JSON.stringify(userInfo));
          this.getUserInfo();
        }
      }

      if (window.sayhi.isSkipWxLogin && window.sayhi.isWebviewLoging) {
        // 其他环境--网页
        webviewLoginCallback({ webviewLoginStatus: false });
        this.setState({
          showActivation: true
        });
      }
    });
  }

  render() {
    const { showActivation } = this.state;
    return(
      <div>
        {
          showActivation 
          ? 
            <Activation 
              hideActivation={() => this.hideActivation()}
              callBack={(data) => this.loginSuccess(data)}
              wapLogin
            /> 
          :
            null
        }
        
      </div>
    );
  }
  
}
